module.exports = require("@mui/icons-material/SkipPrevious");